import React, { Component } from 'react';
import { ROOT_DIR } from '../../utils/Constants';

class SectionLoader extends Component {
  render(){

    return(
      <div className="section-loader show">
        <div className="loader-text">Getting listings...</div>
        <img src={`${ROOT_DIR}/assets/img/loader.gif`} alt="Getting listings..."/>
        <span className="sr-only">Loading...</span>
      </div>
    );
  }
}
export default SectionLoader;


// WEBPACK FOOTER //
// ./src/components/pieces/SectionLoader.js